import React from 'react'
import styled from 'styled-components'
import { getAllLogs } from '@state/actions/logs'
import { useLogs } from '@state/uses/logs'
import * as Utils from '@services/utils'
import PaginatedTable from '@components/Table/PaginatedTable'
import i18n from '@localization/i18n'

const dateFormat = 'H:mm DD/MM/YY'
const filters = [
    {
        property: 'action',
        label: i18n.t('logs_table_filters.action_type'),
        placeholder: i18n.t('logs_table_filters.action_type'),
    },
    {
        property: 'user',
        subProperty: ['first_name', 'last_name'],
        label: i18n.t('logs_table_filters.choreographer_name'),
        placeholder: i18n.t('logs_table_filters.choreographer_name'),
    },
    {
        property: 'user_type',
        label: i18n.t('logs_table_filters.user_type'),
        placeholder: i18n.t('logs_table_filters.user_type'),
    },
]

const columns = [
    {
        property: 'action',
        label: i18n.t('logs_table.action'),
        align: 'start',
        minWidth: '60px',
        sortable: true,
        isMobileTileHeader: true,
    },
    {
        property: 'created',
        label: i18n.t('logs_table.created'),
        align: 'start',
        minWidth: '60px',
        sortable: true,
        cell: (log) => Utils.formatDate(log['created'], dateFormat),
    },
    {
        property: 'user_name',
        label: i18n.t('logs_table.user_name'),
        align: 'start',
        minWidth: '60px',
        sortable: true,
    },
    {
        property: 'user_email',
        label: i18n.t('logs_table.user_email'),
        align: 'start',
        minWidth: '60px',
        sortable: true,
    },
    {
        property: 'user_is_admin',
        label: i18n.t('logs_table.user_is_admin'),
        align: 'start',
        minWidth: '60px',
        sortable: true,
        cell: (log) => (log.user_is_admin ? 'אדמין' : 'משתמש רגיל'),
    },
    {
        property: 'dance_name',
        label: i18n.t('logs_table.dance_name'),
        align: 'start',
        minWidth: '60px',
        sortable: true,
    },
    {
        property: 'target_user_name',
        label: i18n.t('logs_table.target_user_name'),
        align: 'start',
        minWidth: '60px',
        sortable: true,
    },
    {
        property: 'target_user_email',
        label: i18n.t('logs_table.target_user_email'),
        align: 'start',
        minWidth: '70px',
        sortable: true,
    },
    {
        property: 'description',
        label: i18n.t('logs_table.description'),
        align: 'start',
        minWidth: '100px',
        sortable: true,
    },
    {
        property: 'target_group',
        label: i18n.t('logs_table.target_group'),
        align: 'start',
        minWidth: '100px',
        sortable: true,
    },
]

export default ({}) => {
    return (
        <Container>
            <PaginatedTable
                title={'פעולות מערכת'}
                columns={columns}
                collection={'logs'}
                useFunction={useLogs}
                loadAction={getAllLogs}
                filters={filters}
                withDateFilters
            />
        </Container>
    )
}

const Container = styled.div`
    /* display: flex;
    flex-direction: column; */
`
